/*
 * @Author: zhangzc
 * @Email: zhicheng.zhang@medbanks.cn
 * @Date: 2020-03-27 13:57:52
 * @Last Modified by: zhangzc
 * @Last Modified time: 2020-03-27 13:57:52
 * @Description: 公共请求封装
 * @Route: Route
 */

import Axios from 'axios';
import { Toast } from 'vant';

console.log('当前环境', process.env.NODE_ENV);
const BASE_URL =
    process.env.NODE_ENV !== 'production'
        ? 'https://api-gateway.medbanks-test.com'
        : 'https://api-gateway.medbanks.cn';

const fetch = async (config) => {
    const {
        method,
        params,
        independent,
        url,
        timeout,
        headers: headerInfo,
        ...other
    } = config;
    const token = localStorage.getItem('authentication');
    let headers = null;
    if (url.indexOf('/server/') >= 0) {
        headers = {
            ...headerInfo,
        };
    } else {
        headers = {
            token,
            ...headerInfo,
            platformId: 1,
        };
    }
    // 创建axios实例
    const axiosIns = Axios.create();
    let options = {
        headers,
        baseURL: BASE_URL,
        url,
        ...other,
        timeout: timeout || 1 * 60 * 1000,
    };

    if (method === 'post') {
        options = {
            ...options,
            method: 'post',
            data: params,
        };
    } else {
        options = {
            ...options,
            method: 'get',
            params,
        };
    }

    const response = await axiosIns(options)
        .then((res) => {
            const { code, message } = res.data;
            // independent 存在做单独异常处理，其余走统一业务处理
            if (independent) return res;
            if (code !== '0') {
                // code不为0视为错误
                Toast.fail(message);
                return false;
            }
            return res.data;
        })
        .catch((error) => {
            const { message, response: resInfo } = error;
            if (/timeout\sof\s\d+ms\sexceeded/.test(message)) {
                Toast.fail('网络不稳定，请稍后重试');
            }
            if (resInfo) {
                switch (resInfo.status) {
                    case 404:
                        Toast.fail('请求的资源不存在');
                        break;
                    case 500:
                        Toast.fail('服务异常，请稍后重试');
                        break;
                    case 503:
                        Toast.fail('服务器正在维护，请稍后重试');
                        break;
                    default:
                }
            }
            return false;
        });

    return response;
};

export default fetch;
